import { maskCnpj } from './maskCnpj';
import { maskCpf } from './maskCpf';
export function maskDocument(document) {
    if (!document || typeof document !== 'string') {
        return '';
    }
    const cleanDocument = document.replace(/\D/g, '');
    if (cleanDocument.length === 0) {
        return '';
    }
    if (cleanDocument.length <= 11) {
        return maskCpf(document);
    }
    else {
        return maskCnpj(document);
    }
}
